import { render, staticRenderFns } from "./SelfHeader.vue?vue&type=template&id=9366d584&scoped=true&"
import script from "./SelfHeader.vue?vue&type=script&lang=js&"
export * from "./SelfHeader.vue?vue&type=script&lang=js&"
import style0 from "./SelfHeader.vue?vue&type=style&index=0&id=9366d584&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9366d584",
  null
  
)

export default component.exports